import axios from "axios";

// Auto-detect the backend URL from the current domain at runtime.
// Frontend and backend are always served from the same origin (/api routing),
// so window.location.origin is always correct — even if the build-time
// REACT_APP_BACKEND_URL env var is misconfigured.
const BACKEND_URL =
    typeof window !== "undefined" && window.location.origin.startsWith("http")
        ? window.location.origin
        : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const fetcher = (url) => api.get(url).then((r) => r.data);
